var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Container } from './styles';
var Button = function (_a) {
    var id = _a.id, className = _a.className, text = _a.text, onClick = _a.onClick, disabled = _a.disabled, _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement(Container, { id: id, className: className, onClick: onClick, disabled: disabled, style: __assign({ opacity: disabled ? 0.5 : 1 }, style) }, text));
};
export default Button;
